import { gql } from "@apollo/client";

import { GRAPHQL_METHODS } from "../../utils/constants";
import { dateToISO } from "../../utils/dates";
import { networkGraphqlRequest } from "../../utils/networkUtils";

const SAVE_RESULT = gql`
  mutation submitResult($cmd: SaveAnswerCmd!) {
    saveResult(cmd: $cmd)
  }
`;

export function requestDataResult(client, result, complaintId, urlFile) {
  const params = {
    cmd: {
      approvalDate: result.approvalDate ? dateToISO(result.approvalDate) : null,
      attentionDays: parseInt(result.businessDays),
      responseMedium: result.responseMedium,
      observer: result.observation,
      responseDays: parseInt(result.responseDays),
      pendingBy: parseInt(result.pending),
      result: {
        indemnization: parseInt(result.compensation),
        indemnizationProcedure: parseInt(result.compensationProcess),
        paymentResponsible: result.responsibleForPayment,
        paymentDate: result.paymentDate ? dateToISO(result.paymentDate) : null,
        letterClientResponse: urlFile.length === 0 ? null : urlFile[0],
        businessName: result.socialReason,
        bankAccount: result.bankAccount,
        bank: result.bank,
        transactionDocument: result.transactionDocument,
        caseNumber: complaintId,
      },
    },
  };
  return networkGraphqlRequest(
    GRAPHQL_METHODS.MUTATION,
    client,
    SAVE_RESULT,
    params
  );
}
